import { FC } from "react";
import { BaseIcon, IPropsIcon } from "./BaseIcon";

interface IProps extends IPropsIcon {
  onClick?: () => void;
}

export const UserIcon: FC<IProps> = ({ size = 15, fill = "none", onClick }) => {
  return (
    <BaseIcon
      size={size}
      viewBox="0 0 15 16"
      fill={fill}
      onClick={onClick && onClick}
    >
      <path
        d="M10.0107 9.5C9.10449 9.5 8.69824 10 7.22949 10C5.72949 10 5.32324 9.5 4.41699 9.5C2.10449 9.5 0.229492 11.4062 0.229492 13.7188V14.5C0.229492 15.3438 0.885742 16 1.72949 16H12.7295C13.542 16 14.2295 15.3438 14.2295 14.5V13.7188C14.2295 11.4062 12.3232 9.5 10.0107 9.5ZM12.7295 14.5H1.72949V13.7188C1.72949 12.2188 2.91699 11 4.41699 11C4.88574 11 5.60449 11.5 7.22949 11.5C8.82324 11.5 9.54199 11 10.0107 11C11.5107 11 12.7295 12.2188 12.7295 13.7188V14.5ZM7.22949 9C9.69824 9 11.7295 7 11.7295 4.5C11.7295 2.03125 9.69824 0 7.22949 0C4.72949 0 2.72949 2.03125 2.72949 4.5C2.72949 7 4.72949 9 7.22949 9ZM7.22949 1.5C8.85449 1.5 10.2295 2.875 10.2295 4.5C10.2295 6.15625 8.85449 7.5 7.22949 7.5C5.57324 7.5 4.22949 6.15625 4.22949 4.5C4.22949 2.875 5.57324 1.5 7.22949 1.5Z"
        fill="#0D0D0E"
      />
    </BaseIcon>
  );
};
